import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'react-map-gl';
import StopPopupDetail from './StopPopupDetail';

export default class StopPopup extends PureComponent {
  render() {
    const {
      onSelect, enableAccessibilityOutlines, selectedStop, onPopupClose, offset,
    } = this.props;

    if (selectedStop?.stop_lat && selectedStop?.stop_lon) {
      return (
        <Popup
          className="map__stop-popup"
          closeButton
          closeOnClick={false}
          dynamicPosition={false}
          latitude={selectedStop.stop_lat}
          longitude={selectedStop.stop_lon}
          onClose={onPopupClose}
          offset={offset}
        >
          <StopPopupDetail stop={selectedStop} onSelect={onSelect} enableAccessibilityOutlines={enableAccessibilityOutlines} />
        </Popup>
      );
    }
    return null;
  }
}

StopPopup.propTypes = {
  enableAccessibilityOutlines: PropTypes.func.isRequired,
  offset: PropTypes.number.isRequired,
  onPopupClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedStop: PropTypes.object,
};
StopPopup.defaultProps = {
  selectedStop: null,
};
